import {EntityState, EntityStore, QueryEntity, StoreConfig} from "@datorama/akita"
import {ApiSystemWidgetResult} from "app/Interface/Api/System/ApiSystemWidget"
import produce from "immer"

export interface SystemWidgetStoreProps extends EntityState<ApiSystemWidgetResult, string> {
  loading: undefined
}

@StoreConfig({name: 'system.widget', resettable: true, producerFn: produce})
export class SystemWidgetStore extends EntityStore<SystemWidgetStoreProps> {
  constructor() {
    super({
      loading: undefined
    })
  }
}

export const systemWidgetStore = new SystemWidgetStore()


class SystemWidgetQuery extends QueryEntity<SystemWidgetStoreProps> {
  constructor(protected store: SystemWidgetStore) {
    super(store)
  }
}

export const systemWidgetQuery = new SystemWidgetQuery(systemWidgetStore)
